module.exports = __webpack_public_path__ + "assets/img/智骑宝.b55bfdee.jpg";